var DataTable = require('datatables.net');

$.fn.DataTable = DataTable;
